import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';
import WaitlistApi from '../../apis/waitlist';


export const getDisplayProperties = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_DISPLAY_PROPERTIES,
      api: WaitlistApi.getDisplayProperties,
      successCallback: response => {
        dispatch({
          type: types.GET_DISPLAY_PROPERTIES,
          payload: response.properties,
        });
      },
      useErrorDialog: true,
    }));
  };
};

export const filter = (options, successCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.FILTER,
      api: WaitlistApi.filter,
      param: options,
      successCallback: response => {
        dispatch({
          type: types.FILTER,
          payload: response.items,
        });

        if (successCb) successCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const request = (requestObject, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.REQUEST_WAITLIST,
      api: WaitlistApi.request,
      param: requestObject,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/waitlist/waitlistActions.js